import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { sanitizeOpenLinkUrl } from 'utils/sanitize-open-link-url';

const useConditionalNavigation = (): void => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const navigateTo = useCallback(
    (path: string, isReplace: boolean = false): void => {
      const currentFullPath = pathname + search;
      if (currentFullPath !== path) {
        if (isReplace) {
          navigate(path, { replace: true });
        } else {
          navigate(path);
        }
      }
    },
    [navigate, pathname, search],
  );

  useEffect(() => {
    const lastRelevantPath = sessionStorage.getItem('lastRelevantPath') || '/';

    let modifiedPathname = pathname;

    if (modifiedPathname.includes('/member')) {
      modifiedPathname = modifiedPathname.replace('/member', '');
      navigateTo(modifiedPathname + search, true);
    }

    if (modifiedPathname.includes('/about-me')) {
      navigateTo('/dashboard', true);
    }

    // if (modifiedPathname === '/achievements') {
    //   navigateTo('/dashboard?view=achievements', true);
    // }

    if (search?.includes('openLink')) {
      const cleanedQueryString = sanitizeOpenLinkUrl(search ?? '');

      const queryParams = new URLSearchParams(cleanedQueryString);

      const linkType = queryParams.get('link');
      if (linkType === 'activity') {
        const activityId = queryParams.get('activityId');
        const campaignId = queryParams.get('campaignId');

        if (activityId && campaignId) {
          const targetPath = `/health-journey/campaign/${campaignId}/activity/${activityId}/toolbox`;
          navigateTo(targetPath, lastRelevantPath === '/forms');
        }
      }
    }

    sessionStorage.setItem('lastRelevantPath', modifiedPathname);
  }, [navigateTo, pathname, search]);
};

export default useConditionalNavigation;
